// author @xys
// js sdk 权限获取
// 权限列表需要在引入该文件的 .vue 文件中列好（this.jsApiList:['getLocation']）
import {
	getJSSKDAccessToken,
	getTicket,
	getWxJSSDKSignature,
	appid
} from "@/utils/api/wx";
// const expirationTimer = 7000;
import store from "@/store";
// 检查是否过期
export const expiredChecked = (temp) => {
	const now = Date.parse(new Date()) / 1000;
	const ex = now >= parseInt(temp);
	return ex;
};
export const signature = {
	methods: {
		// 注册当前页面的js 功能权限
		// 签名、时间戳、随即串 皆在后台生成
		async regPagePower(jsapi_ticket) {
			let realUrl = window.location.origin + this.$route.fullPath;
			getWxJSSDKSignature({
				ticket: jsapi_ticket,
				url: realUrl
			}).then((res) => {
				console.log(res)
				if (res.success) {
					let config = {
						debug: false,
						appId: appid,
						timestamp: res.data.timestamp,
						nonceStr: res.data.noncestr,
						signature: res.data.signature,
						// 在页面定义data内定义页面需要的wx-js权限
						jsApiList: this.jsApiList
					};
					wx.config(config);
					wx.error(function(res){
						console.log('**',res)
					});
				}
			});
		}
	},
	async created() {
		if(localStorage.getItem('port')=='douyin') return;
		// 获取全局token;
		let jsToken = store.state.jsSDKAccessToken;
		if (!jsToken.access_token || expiredChecked(jsToken.expire_timestamp)) {
			// token 不存在、过期
			// 获取jssdk token
			const {
				data
			} = await getJSSKDAccessToken();
			if (!data.errcode) {
				// 缓存 token sdk返回默认时间为7200s
				const cacheData = {
					access_token: data.access_token,
					expire_timestamp: Date.parse(new Date()) / 1000 + (parseInt(data.expires_in) -
						1600) // 设置过期时间 110分钟过期
				};
				store.commit("SET_JSSDK_ACCESS_TOKEN", cacheData); // 存入jsToken
				jsToken = cacheData;
			} else {
				if (data.errcode !== 45009) {
					this.$root.$toast.fail(data.errmsg);
				}
			}
		}
		// 获取全局 ticket
		let jsTicket = store.state.jsTicket;
		if (!jsTicket.jsapi_ticket || expiredChecked(jsTicket.expire_timestamp)) {
			// ticket 不存在、过期
			const {
				data
			} = await getTicket(jsToken.access_token);
			if (data.errcode == 0) {
				const cacheData = {
					jsapi_ticket: data.ticket,
					expire_timestamp: Date.parse(new Date()) / 1000 + (parseInt(data.expires_in) -
						1600) // 设置过期时间 110分钟过期
				};
				store.commit("SET_WX_TICKET", cacheData); // 存入 jsTicket
				jsTicket = cacheData;
			} else {
				if (data.errcode !== 42001) {
					this.$root.$toast.fail(data.errmsg);
				}
			}
		}
		this.regPagePower(jsTicket.jsapi_ticket);
	}
};
